import React from 'react'
import { Link } from "react-router-dom";
import P1 from './P1'
import CartItem from "./CartItem";
import img5 from "../../Images/p-5.jpg"
import Footer from './Footer'
import "./cart.css"

import { useSelector } from 'react-redux'

const Cart = () => {

  const cart = useSelector((state) => state.cart)

  // For Grand Total
  const getTotal = () => {
    let totalQuantity = 0
    let totalPrice = 0
    cart.forEach(item => {
      totalQuantity += item.quantity
      totalPrice += item.Price * item.quantity
    })
    return { totalQuantity, totalPrice }
  }

  return (


    <>
      <P1 topimg={img5} topText="Cart" />

      <div className="container Cart">

        <div className="CartBox">


          {cart.length > 0 ? (
            <React.Fragment>
              {cart.map((items) => (
                <CartItem
                  key={items.Id}
                  id={items.Id}
                  cover={items.Cover}
                  name={items.Name}
                  price={items.Price}
                  about={items.About}
                  stars={items.Stars}
                  quantity={items.quantity} />
              ))}

              <div className="grandTotal">
                <h1>Order Summary</h1>
                <div className="cartAPNA ">
                  <div className="Grid2">
                    <h2>Total Items: {getTotal().totalQuantity}</h2>
                    <h2 className='qpp'>Grand Total: $ {getTotal().totalPrice}</h2> 
                  </div>
                  <div className='btn'>
                      <button className="checkout-btn">
                        <i className='fa fa-check'> </i>  CheckOut Now
                      </button>
                  </div>
                </div>
              </div>

            </React.Fragment>
          ) : (

            <h2>Your Cart is empty, Do some shopping dude ...</h2>


          )
          }






        </div>

        <button className="btnCartA">
          <Link to="/pizza">
            <i class="fa-solid fa-store"></i>
            <span>Go to Shop</span>
            <i class="fa-solid fa-arrow-right-long"></i>
          </Link>
        </button>

      </div>

      <Footer />

    </>
  )
}

export default Cart
